import React, { Suspense } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import routes from "~react-pages";
import { AuthProvider } from "@/contexts/AuthContext";

function FileBasedRoutes() {
  // Check if routes is a function and call it if needed
  const routesData = typeof routes === "function" ? routes() : routes;

  // Helper function to process route and its children recursively
  const processRoute = (route) => {
    // Get the route name from path for customized loading messages
    const routeName = route.path ? route.path.split("/").pop() : "page";
    const loadingMessage = `Loading ${routeName}...`;

    // Base configuration for the route
    const processedRoute = {
      ...route,
      element: route.element ? (
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen bg-black text-white">{loadingMessage}</div>}>
          {route.element}
        </Suspense>
      ) : undefined,
    };

    // If the route has children, process them recursively
    if (route.children) {
      processedRoute.children = route.children.map((child) => processRoute(child));
    }

    return processedRoute;
  };

  // Process all routes
  const processedRoutes = Array.isArray(routesData)
    ? routesData.map((route) => processRoute(route))
    : [processRoute(routesData)]; // Handle single route case

  return useRoutes(processedRoutes);
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FileBasedRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}